<footer class="mt-4 py-4 px-4 border-top bg-light">
    <div class="container">
        <span class="mb-3 mb-md-0 text-muted">&copy; 2026 yantech ApS</span>
    </div>
</footer>